module.exports = __webpack_public_path__ + "44ff4de5256bf2d863f654376e180040.pdf";